import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { TaskTemplatesManagementView } from "src/components/views/tasks/taskTemplates/TaskTemplatesManagementView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/tasks/taskTemplates")({
	staticData: { title: i18n.t("task_templates"), legacyViewKey: "taskTemplatesPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <TaskTemplatesManagementView />;
}
